var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header'),_c('div',{staticClass:"content"},[_c('h3',[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"text_content",domProps:{"innerHTML":_vm._s(_vm.html)}})]),_c('gap',{attrs:{"height":"50"}}),_c('Homefooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }